import { AnalyticsEvent as LegacyAnalyticsEvent } from '@backstage/core-plugin-api';
import {
  AnalyticsEvent,
  AnalyticsImplementation,
} from '@backstage/frontend-plugin-api';

import { Confidence } from '@spotify-confidence/sdk';

import { ConfidenceUserApi } from './UserApi';

export class ConfidenceAnalytics implements AnalyticsImplementation {
  confidenceApi: Confidence;
  confidenceUserApi: ConfidenceUserApi;
  accessTokenData: Record<string, string | string[]> | undefined;

  constructor({
    confidenceApi,
    confidenceUserApi,
  }: {
    confidenceApi: Confidence;
    confidenceUserApi: ConfidenceUserApi;
  }) {
    this.confidenceApi = confidenceApi;
    this.confidenceUserApi = confidenceUserApi;
  }

  private async getAccessTokenData() {
    if (this.accessTokenData) {
      return this.accessTokenData;
    }
    const credentials = await this.confidenceUserApi.getCredentials();
    const token = await credentials.getTokenSilently();
    const accessTokenData = JSON.parse(window.atob(token.split('.')[1]));
    this.accessTokenData = accessTokenData;
    return accessTokenData;
  }

  async captureEvent(event: AnalyticsEvent | LegacyAnalyticsEvent) {
    const { action, subject, value, attributes = {} } = event;

    let user;

    try {
      const tokenData = await this.getAccessTokenData();
      // in the next release this user context will be handled by a context provider instead
      user = {
        account: tokenData['https://confidence.dev/account_name'] || '',
        user: tokenData['https://confidence.dev/user_name'] || '',
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.debug('Could not get Confidence user credentials');
      user = {};
    }

    try {
      this.confidenceApi
        .withContext({
          user,
        })
        .track(action, {
          subject,
          value: value || 0,
          attributes,
        });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
}
